import { CategoryIBMAdminDetailsBreadcrumb } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class Category<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Gets catalogs by search term.
	 *
	 * @tags Category
	 * @name CategoryFindBySearchTerm
	 * @summary Get catalogs by search term
	 * @request GET:/store/{storeId}/category/bySearchTerm/{searchTerm}
	 * @secure
	 * @response `200` `CategoryIBMAdminDetailsBreadcrumb` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	categoryFindBySearchTerm = (
		storeId: string,
		searchTerm: string,
		query?: {
			/** Language identifier. If not specified, the "locale" parameter is used. If "locale" is not specified, then the store default language is used. */
			langId?: string;
			/** The unique ID of the catalog to search the categories under. */
			catalogId?: string;
			/** Profile name. Profiles determine the subset of data returned by a query. */
			profileName?:
				| 'IBM_Admin_Summary'
				| 'IBM_Admin_Details'
				| 'IBM_Admin_Summary_Breadcrumb'
				| 'IBM_Admin_Details_Breadcrumb';
			/**
			 * Page number. Valid values are positive integers starting at 1. Use pageNumber with pageSize.
			 * @format int32
			 */
			pageNumber?: number;
			/**
			 * Page size. Used to limit the amount of data returned by a query. Valid values are integers starting with 1. Use pageSize with pageNumber.
			 * @format int32
			 */
			pageSize?: number;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['categoryFindBySearchTerm'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/category/bySearchTerm/${searchTerm}`,
				params: _params,
				query: query,
				methodName: 'categoryFindBySearchTerm',
			};
			logger.trace(traceData);
		}
		return this.http.request<CategoryIBMAdminDetailsBreadcrumb, void>({
			path: `/store/${storeId}/category/bySearchTerm/${searchTerm}`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
